GT.MobileNavigationV2 = function ($element) {
    let me = this,
        globalReachElm = document.querySelector(".global-reach"),
        back2mainElm = globalReachElm.querySelector(".global-reach-toggle-header"),
        headerTileElm = globalReachElm.querySelector(".global-reach-mobile-header__title"),
        globalSearch = document.querySelector(".global-search"),
        toggleElm = document.querySelector('.global-toggle-m'),
        gReachText = "",
        megaNavWrapper = document.querySelector('.mega-wrapper');

    me.init = function () {
        let hamburger = {
            headerMenu: document.querySelector('.header-menu'),
            navToggle: document.querySelector('.menu-toggle'),
            doToggle: function(e, isClose) {
                e.preventDefault();
                
                setTimeout(function() {

                    if(isClose)
                        hamburger.headerMenu.classList.add('open');
                    
                    if(globalReachElm.classList.contains("open")) {
                        globalReachElm.classList.remove("open");
                        globalReachElm.classList.remove("global-reach-mobile");
                    }

                    // Close search form when mobile menu is open
                    if(globalSearch.classList.contains('search-open')) {
                        globalSearch.classList.remove('search-open');
                        globalSearch.closest('.main-header').classList.remove('search-open');
                    }

                }, 100);
            }
        };


        hamburger.navToggle.addEventListener('click', function(e) {            

            let isClose = true;
            if(hamburger.navToggle.classList.contains('open')) {
                megaNavWrapper.classList.remove('open');
                hamburger.headerMenu.classList.remove('open');
                document.firstElementChild.classList.remove("opening-mobile-menu");
                document.firstElementChild.classList.remove("opening-megamenu");
                document.firstElementChild.classList.remove("overflowHidden");
                isClose = false;
                document.querySelector(".gt-wrapper").removeAttribute("inert");
                hamburger.headerMenu.removeAttribute("inert");
                hamburger.navToggle.setAttribute("aria-expanded", false);
            } else {
                let onPageNav = document.querySelector(".onpage-navigation.expanded");
                if (onPageNav) {
                    document.firstElementChild.classList.remove("showing-overlay");
                    onPageNav.classList.remove("expanded");
                }
                defaultPossitionMobileMenu();
                GT.lockScrollBehindOverlay(".header-menu");
                document.firstElementChild.classList.add("opening-mobile-menu");
                document.firstElementChild.classList.add("overflowHidden");
                
                GT.touchMoveFncList.preventTouchMoveOnHeaderMenu = function(e){
                    if(!e.target.closest(".header-menu") && !e.target.closest(".global-reach")  && !e.target.closest(".mega-wrapper")) {
                        if(hamburger.navToggle.classList.contains('open'))
                            e.preventDefault();
                    }
                }
                document.querySelector(".gt-wrapper").setAttribute("inert", true);
                hamburger.navToggle.setAttribute("aria-expanded", true);
            } 

            let lv3OpeningItem = document.querySelector('.mega__level--3.open'),
                lv2OpeningItem = document.querySelector('.bleed.open');
                
            if(lv2OpeningItem) {
                lv2OpeningItem.classList.remove('open');
                lv2OpeningItem.classList.remove('slide-left');
            }

            if(lv3OpeningItem) 
                lv3OpeningItem.classList.remove('open');

            document.querySelector('.mega__level').classList.remove('open');
            hamburger.navToggle.classList.toggle('open');

            hamburger.doToggle(e, isClose);
        });

        document.querySelectorAll('.global-toggle-m').forEach(function(elm, idx){
            if(idx == 0) {
                elm.addEventListener('click', function(e) {
                    if(!gReachText) {
                        gReachText = toggleElm.innerText;
                    }
        
                    if(!globalReachElm.classList.contains("global-reach-mobile")) {
                        let activeElm = document.querySelector(".reach-region-selector li.active");
                        if(activeElm)
                            activeElm.classList.remove("active");
        
                        headerTileElm.innerText = gReachText;
                        globalReachElm.classList.remove("opening-lv2");
                        globalReachElm.classList.add("global-reach-mobile");

                        GT.lockScrollBehindOverlay(".global-reach-mobile");
                        
                        hamburger.headerMenu.setAttribute("inert", true);
                        megaNavWrapper.setAttribute("inert", true);
                    } else
                        globalReachElm.classList.remove("global-reach-mobile");
                })
            } else {
                elm.addEventListener('click', function(e) {
                    // If the click is on the mega-wrapper, trigger click for the first global-toggle-m to load the global reach content
                    if(e.target.closest('.mega-wrapper')) {
                        document.querySelector('.global-toggle-m').click();
                    }
                })
            }
        })  

        document.querySelectorAll(".reach-region-selector li").forEach(function(elm){
            GT.clickEvt(elm, e => {
                headerTileElm.innerText = e.target.innerText;
                setTimeout(e => {
                    globalReachElm.classList.add("opening-lv2");
                }, GT.isMobileCached ? 500 : 0)
            })
        })

        back2mainElm.addEventListener("click", function(){
            let activeElm = document.querySelector(".reach-region-selector li.active");
            if(activeElm) {
                activeElm.setAttribute("aria-expanded", "false");
                activeElm.classList.remove("active");
            }

            if(globalReachElm.classList.contains("opening-lv2")) {
                headerTileElm.innerText = gReachText;
                globalReachElm.classList.remove("opening-lv2");
            } else {
                if(globalReachElm.classList.contains("open")) {
                    globalReachElm.classList.remove("open");
                    globalReachElm.classList.remove("global-reach-mobile");
                    setTimeout(e => {
                        toggleElm.focus();
                    }, 100)
                }
                headerTileElm.innerText = "";
                if(!document.querySelector('.bleed.open'))
                    hamburger.headerMenu.removeAttribute("inert");
                megaNavWrapper.removeAttribute("inert");
            }
        })

        var nav = {
            navItems : document.querySelectorAll('.nav-link--dropdown'),
            secondNavItems: document.querySelectorAll('.bleed .mega-link:not(a)'),
            backButton: megaNavWrapper.querySelector('.nav-level-toggle'),
            navSlideLeft: function() {
                // nav.backButton.focus(); does not work on Safari
                setTimeout(e => {
                    if(GT.wWidth < GT.breakPoints.tablet_lg) {
                        hamburger.headerMenu.setAttribute("inert", true);
                    }
                    megaNavWrapper.classList.add('open');
                    document.querySelector('.mobile__level-header').classList.remove('hide');
                    setTimeout(e => {
                        (document.querySelector('.bleed.open .bleed__col--left .mega-header a') || document.querySelector('.bleed.open .bleed__col--left .mega-link'))?.focus();
                    },50)
                }, 100)
            },
            navSlideLeft2x: function() {
                // nav.backButton.focus(); does not work on Safari
                setTimeout(e => {
                    document.querySelector('.bleed.open').classList.add('slide-left');
                    setTimeout(e => {
                        document.querySelector('.bleed.open .mega__level--3.open .mega-header a')?.focus();
                    }, 50)
                }, 100)
            },
            navSlideRight: function(e) {
                let openedBleed = document.querySelector('.bleed.open');
                if ( openedBleed?.classList.contains('slide-left') ) {
                    openedBleed.classList.remove('slide-left');
                    document.querySelector('.bleed.open .selected button')?.setAttribute("aria-expanded", false);
                    document.querySelector('.bleed.open .selected')?.classList.remove('selected');
                    (document.querySelector('.bleed.open .bleed__col--left .mega-header a') || document.querySelector('.bleed.open .bleed__col--left .mega-link'))?.focus();
                } else {
                    document.querySelector('.nav-link--dropdown.open')?.setAttribute("aria-expanded", false);
                    megaNavWrapper.classList.remove('open');
                    document.querySelector('.bleed.open').classList.remove('open');
                    document.querySelector('.mobile__level-header').classList.add('hide');
                    hamburger.headerMenu.removeAttribute("inert");
                    document.querySelector(".nav-link")?.focus();
                    // hamburger.navToggle.focus(); does not work on Safari
                }
            }
        };

        if(GT.wWidth < GT.breakPoints.tablet_lg) {
            nav.navItems.forEach(item => {
                item.addEventListener("click", function(e) {
                    if(GT.wWidth < GT.breakPoints.tablet_lg)
                        e.preventDefault();
                        
                    nav.navSlideLeft(e);
                });
            })
            
            nav.secondNavItems.forEach(item => {
                item.addEventListener("click", (e) => {
                    e.preventDefault();
                    nav.navSlideLeft2x(e);
                })
            })

            nav.backButton.addEventListener("click", (e) => {
                nav.navSlideRight(e);
            });

            GT.windowResizeFncList.mobileNav2 = function(){
                hamburger.navToggle.classList.remove('open');
                hamburger.headerMenu.classList.remove('open');
                hamburger.headerMenu.removeAttribute("inert");
                document.firstElementChild.classList.remove("overflowHidden");
                megaNavWrapper.classList.remove('open');
                globalReachElm.classList.remove("open");
                globalReachElm.classList.remove("global-reach-mobile");
                document.firstElementChild.classList.remove("global-reach--opening");
            }
        }

        window.addEventListener("resize", function() {
            defaultPossitionMobileMenu();
        })
    }

    function defaultPossitionMobileMenu() {
        let headerElmH = 64,
            topPosition = document.querySelector('.main-header').getBoundingClientRect().y,
            _primaryNav = document.querySelector('.header-menu');

        if(GT.isMobileView()) {
            const elmHeight = 'calc(var(--window-height) - '+ (topPosition + headerElmH) +'px)';

            _primaryNav.style.height = elmHeight;
            
            megaNavWrapper.style.height = elmHeight;
            megaNavWrapper.style.maxHeight = 'auto';
            
            globalReachElm.style.height = elmHeight;
            
        } else {
            // Calculate height of mobile menu
            // _primaryNav.style.top = 'auto';
            _primaryNav.style.height = 'auto';
            
            // megaNavWrapper.style.top = 'auto';
            megaNavWrapper.style.height = 'auto';
            // globalReachElm.style.top = '0';
        }
    }
        
    me.init();
};
GT.MegaNavigationV2 = function($element) {
    if(typeof isNav3 != "undefined") return;

    let _activeMenuTier2 = null;
    let _linkLv1 = document.querySelectorAll('.nav-link');
    let _level2 = document.querySelector('.mega__level--2');
    let _closeMegaIcons = document.querySelectorAll('.close-mega__menu'),
        _megaWrapper = document.querySelector('.mega-wrapper');

    init();
    function closeSecondary() {
        _level2.classList.remove('open');
        document.firstElementChild.classList.remove("opening-megamenu");

        _megaWrapper.setAttribute("inert", true);
        [].forEach.call(_linkLv1, function(item) {
            item.classList.remove('open');
            item.removeAttribute('tabindex');
            if (item.classList.contains('nav-link--dropdown'))
                item.setAttribute('aria-expanded', 'false');
        });

        let _bleedItems = _level2.querySelectorAll('.bleed');
        for(let i = 0; i < _bleedItems.length; i++) {
            let _bleed = _bleedItems[i];
            _bleed.classList.remove('open');
        }
    };

    function openSecondary(t) {
        let htmlElm = document.firstElementChild;
        if(htmlElm.classList.contains("global-reach--opening"))
            return;
        let _key = t;

        htmlElm.classList.add("opening-megamenu");

        let _extraMenu = document.querySelector('.menu-link');
        if(_extraMenu != null && _extraMenu.classList.contains('open')) {
            _extraMenu.classList.remove('open');
            _extraMenu.querySelector('button.nav-link').blur();
        }
        
        let _globalSearch = document.querySelector('.global-search');
        _globalSearch.classList.remove('open');
        _globalSearch.querySelector('input[name="q"]').blur();

        let _bleedItems = _level2.querySelectorAll('.bleed');

        for(let i = 0; i < _bleedItems.length; i++) {
            let _bleedItem = _bleedItems[i];
            _bleedItem.classList.remove('open');
            if(_bleedItem.getAttribute('data-content') == _key) {
                _activeMenuTier2 = _bleedItem;
                _bleedItem.classList.add('open');
                _megaWrapper.removeAttribute("inert");
            } else {
                _bleedItem.classList.remove('open');
            }
        }

        let _navLinksLevl2 = _activeMenuTier2.querySelectorAll('.mega-link--level-2');
        for (let i = 0; i < _navLinksLevl2.length; i++) {
            let _navLink2 = _navLinksLevl2[i];
            _navLink2.addEventListener("click", openTertiery);
            _navLink2.addEventListener("mouseenter", GT.throttle(function(){ 
		        const context = this, args = arguments;
                openTertiery.apply(context, args);
            }));
        }

        let highlightElm = _level2.querySelector(".highlight"),
            selectedElms = _level2.querySelectorAll(".selected:not(.mega-content__item)");

        if(selectedElms.length) {
            selectedElms.forEach(function(selectedElm) {
                selectedElm.classList.remove("selected");
            })
        }

        if(highlightElm) {
            highlightElm.classList.add("selected");
        }

        defaultSelectedItem(_activeMenuTier2);
        
        setTimeout(function() {
            promoteArticle();
        }, 100);

        setMegaPossition();
        _level2.classList.add('open');
    };

    function openTertiery() {
        let _this = this;
        if(_this.classList.contains('not-arrow')) return;
        let _key = this.getAttribute('data-id');

        let parentListMenu = _this.closest('ul.list');

        let listMenus = parentListMenu.querySelectorAll('li.selected');
        [].forEach.call(listMenus, function(item) {
            item.classList.remove('selected');
            item.querySelector("button")?.setAttribute("aria-expanded", false);
        });

        _this.closest(".bleed").querySelector(".group-name-text.selected")?.classList.remove("selected");

        if(_activeMenuTier2 == null || _activeMenuTier2.length <= 0) return;
        
        let _megaLevl3Items = _activeMenuTier2.querySelectorAll('.mega__level--3');
        for(let i = 0; i < _megaLevl3Items.length; i++) {
            let _megaLevl3 = _megaLevl3Items[i];
            _megaLevl3.classList.remove('open');
            if(_megaLevl3.getAttribute('data-feature') == _key) {
                _megaLevl3.classList.add('open');
                _this.parentNode.classList.add('selected');
                _this.setAttribute("aria-expanded", true);
            } else {
                _megaLevl3.classList.remove('open');
            }
        }

        promoteArticle();
    };

    function promoteArticle() {
        let _featuredMega = document.querySelector('.mega__level--3.open');
        if(!_featuredMega) return;
        let _promoteArticles = _featuredMega.querySelectorAll('.article-tile');
        [].forEach.call(_promoteArticles, function(_promoteArticle) {
            if(_promoteArticle != null) {
                let _articleHeader = _promoteArticle.querySelector('.article-tile__header');
                let _articleContents = _promoteArticle.querySelector('.article-tile__content-container');
                _promoteArticle.style.height = _articleHeader.getBoundingClientRect().height + _articleContents.getBoundingClientRect().height + 'px';
            }
        });

        setTimeout(function() {
            GT.clampArticle(true);
        }, 200);
    }

    function handleNavOpenEvents(e) {
        const isTablet = GT.isTabletView();
        if(e.target.classList.contains("open") && isTablet) {
            if(e.type == "click" && GT.wWidth >= GT.breakPoints.tablet_lg) {
                closeSecondary();
            }
            return;
        }

        [].forEach.call(_linkLv1, function(item) {
            item.classList.remove('open');
        });

        if(isTablet)
            document.querySelectorAll(".mega__level--3.open").forEach(function(lv3item){
                lv3item.classList.remove("open");
            })

        if(e.type != "click")
            closeSecondary();


        if(this.classList.contains('nav-link--dropdown') && this.getAttribute('aria-expanded') == 'false') {
            this.classList.add('open');
            openSecondary(this.getAttribute('data-open'));
            this.setAttribute('aria-expanded', 'true');

            if(!GT.isMobileCached) {
                _linkLv1.forEach(function(item) {
                    item.setAttribute('tabindex', -1);
                });
                this.removeAttribute('tabindex');
            }
        }
    };

    function keypressNav(e) {
        let keycode = e.keyCode || e.which,
            _this = e.currentTarget,
            _isLastLv3Item = false,
            _key = _this.dataset.id;
        //TAB keypress
        if (keycode == 9 && !GT.isMobileCached) {
            
            if ( _this.getAttribute('aria-expanded') == 'true' ) {
                // menu lv 1 && mega menu is open
                e.preventDefault();
                if (e.shiftKey) {
                    const currentBleedLinks = document.querySelector('.mega__level--3.open')?.querySelectorAll('a, .article-tile');
                    const lastLink = currentBleedLinks[currentBleedLinks.length -1];
                    lastLink && lastLink.focus();
                } else {
                    document.querySelector('.mega__level--2.open .close-mega__menu').focus();
                }
            }
            
            if (_this.classList.contains('close-mega__menu') ) {
                e.preventDefault();
                if (e.shiftKey) {
                    document.querySelector('.nav-link[aria-expanded="true"]')?.focus();
                } else {
                    let _openBleed = document.querySelector('.bleed.open');
                    if (_openBleed)
                        _openBleed.querySelector('a.group-name-text, .mega-link--level-2').focus();
                }
            }

            if (_this.classList.contains('mega-link--level-2') || _this.matches('.group-name-text.selected')) {

                if (e.shiftKey) {
                    let previousLIElm = _this.closest('li').previousElementSibling;
                    if (previousLIElm) {
                        e.preventDefault();
                        if(previousLIElm.classList.contains("group-name-line"))
                            previousLIElm = previousLIElm.previousElementSibling;
                        if(previousLIElm.classList.contains("group-name-text"))
                            previousLIElm = previousLIElm.previousElementSibling;

                        if(previousLIElm)
                            previousLIElm.querySelector('.mega-link--level-2')?.focus();
                        else {
                            _this.closest('.bleed').querySelector('.group-name-text.mega-link, .mega__level--2.open .close-mega__menu')?.focus();
                        }
                    }
                } else {
                    if (this.closest(".selected")) {
                        e.preventDefault();
                        let _parent = _this.closest('.bleed');
                        _menuContainerLv3 = _parent.querySelector('.mega__level--3[data-feature="' + _key + '"]');
                        _menuContainerLv3.querySelector('a').focus();
                    }
                    // check if current level 2 menu is the last menu
                    else if (!_this.closest('li').nextElementSibling) {
                        e.preventDefault();
                        let _parentContent = _this.closest('.bleed').getAttribute('data-content');
                        if (_parentContent)
                            document.querySelector('.nav-link[aria-expanded="true"]')?.focus();
                    }
                }
            }

            if (_this.parentElement.classList.contains('mega-header__title')) {
                if (e.shiftKey) {
                    e.preventDefault();
                    let _key = _this.closest('.mega__level--3').getAttribute('data-feature');
                    _this.closest('.bleed').querySelector('.mega-link--level-2[data-id="' + _key + '"], .group-name-text.selected').focus();
                }
                // check if current is see overview link and does not have the mega lv3 listing
            } else if (!e.shiftKey && _this.classList.contains("mega-see__overview") && !_this.closest('.mega__level--3').querySelector('.mega__level--3__listing')) {
                _isLastLv3Item = true;
            }

            if ( _this.classList.contains('mega-link--level-3')) {
                let _parentItem = _this.closest('.mega-content__item'),
                    _featuredMega = this.closest('.mega__level--3--container').querySelector('.mega-featured');
                // check if current level 3 menu is the last menu
                if ( !_parentItem.nextElementSibling && !_featuredMega ) {
                    _isLastLv3Item = true;
                }
            }

            if ( _this.classList.contains('article-tile') && _this.closest('.mega-featured__contents') )
                _isLastLv3Item = true;
            
            if (_isLastLv3Item  && !e.shiftKey) {
                e.preventDefault();
                let _key = _this.closest('.mega__level--3').getAttribute('data-feature'),
                    _parentBleed = _this.closest('.bleed'),
                    currentMegaLinkLv2 = _parentBleed.querySelector('.mega-link--level-2[data-id="' + _key + '"], .mega-link[data-id="' + _key + '"]'),
                    nextMegaLinkLv2 = currentMegaLinkLv2.classList.contains("mega-link--level-2") 
                        ? currentMegaLinkLv2?.closest('li').nextElementSibling
                        : _parentBleed.querySelector(".mega__content li:not(.selected) .mega-link--level-2");
                
                if ( nextMegaLinkLv2 ) { 
                    // if current level 2 menu is NOT the last menu
                    // focus on next mega link lv2
                    if(nextMegaLinkLv2.classList.contains("group-name-text"))
                        nextMegaLinkLv2 = nextMegaLinkLv2.nextElementSibling;
                    if(nextMegaLinkLv2.classList.contains("group-name-line"))
                        nextMegaLinkLv2 = nextMegaLinkLv2.nextElementSibling;

                    (nextMegaLinkLv2.classList.contains('mega-link--level-2') ? nextMegaLinkLv2 : nextMegaLinkLv2.querySelector('.mega-link--level-2'))?.focus();
                } else {
                    document.querySelector('.nav-link[aria-expanded="true"]')?.focus();
                }
                _isLastLv3Item = false;
            }
        }
        
    }

    function defaultSelectedItem(_currentBleedItem) {
        if (GT.isTabletView()) {
            //if group text on left nav is contain link, it should be selected item
            let groupLinkElements = _currentBleedItem.querySelectorAll('a.group-name-text.highlight');            
            let _defaultSelectedItem = _currentBleedItem.querySelectorAll('.list li.highlight');
            var _firstSelected = null;
            if (_defaultSelectedItem.length <= 0 && groupLinkElements.length <= 0) {
                var megaLevel3Id = null;
                if (_currentBleedItem.querySelectorAll('a.group-name-text').length > 0) {
                    _firstSelected = _currentBleedItem.querySelectorAll('a.group-name-text')[0];
                    megaLevel3Id = _firstSelected.getAttribute('data-id');
                }
                else { 
                    _firstSelected = _currentBleedItem.querySelector('.list li:first-child');
                    let _megaLevl3 = _firstSelected.querySelector('.mega-link--level-2');
                    megaLevel3Id = _megaLevl3 != null ? _megaLevl3.getAttribute('data-id') : null;
                }
                _firstSelected.classList.add('selected');
                _firstSelected.querySelector("button")?.setAttribute("aria-expanded", true);                
                if (megaLevel3Id != null) {
                    let _dataFeatured = megaLevel3Id;
                    let _megaLevl3Item = _currentBleedItem.querySelector('.mega__level--3:first-child');
                    if(_megaLevl3Item != null && _megaLevl3Item.getAttribute('data-feature') == _dataFeatured) {
                        _megaLevl3Item.classList.add('open');
                    }
                }
            } else {
                var megaLevel3Id = null;
                var _megaLevl3;
                if (groupLinkElements.length > 0) {
                    _megaLevl3 = groupLinkElements[0];
                    megaLevel3Id = groupLinkElements[0].getAttribute('data-id');
                } else {
                    _megaLevl3 = _defaultSelectedItem[0].querySelector('.mega-link--level-2');
                    megaLevel3Id = _megaLevl3 != null ? _megaLevl3.getAttribute('data-id') : null;
                }
                
                if (megaLevel3Id != null) {
                    let _dataFeatured = megaLevel3Id;
                    
                    let _parentMenu = _megaLevl3.closest('.bleed');
                    
                    if(!_parentMenu) return;

                    let _megaLevl3Items = _parentMenu.querySelectorAll('.mega__level--3');
                    for(let i = 0; i < _megaLevl3Items.length; i++) {
                        let _megaLevl3 = _megaLevl3Items[i];
                        _megaLevl3.classList.remove('open');
                        if(_megaLevl3.getAttribute('data-feature') == _dataFeatured) {
                            _megaLevl3.classList.add('open');
                        }
                    }
                }
            }
        }
    }

    function registerEvtForOpeningSecondary() {
        for (let i = 0; i < _linkLv1.length; i++) {
            let _navLevel1 = _linkLv1[i];
            if(GT.isMobileView()) {
                _navLevel1.removeEventListener("mouseenter", handleNavOpenEvents);
                _navLevel1.removeEventListener("click", handleNavOpenEvents);
                _navLevel1.addEventListener("click", handleNavOpenEvents);
            } else {
                _navLevel1.removeEventListener("click", handleNavOpenEvents);
                _navLevel1.removeEventListener("mouseenter", handleNavOpenEvents);
                if(!GT.isMobileCached)
                    _navLevel1.addEventListener("mouseenter", handleNavOpenEvents);
                _navLevel1.addEventListener("keydown", keypressNav);
                _navLevel1.addEventListener("click", handleNavOpenEvents);
            }
        }
        
        let _subMenuLinks = document.querySelectorAll('.mega-wrapper .mega-link, .mega-header__title a, .mega-header .mega-see__overview');
        if (_subMenuLinks) {
            [].forEach.call(_subMenuLinks, function(item) {
                item.addEventListener('keydown', keypressNav);
            });
        }
    }

    function setMegaPossition() {
        let _windowWidth = window.innerWidth || document.documentElement.clientWidth || document.body.clientWidth;
        if(_windowWidth >= 960) {
            let _headerUtils = document.querySelector('.header-utils');
            let _topBannerMessage = document.querySelector('.header-message-top-banner-wrapper');
            let _mainHeader = document.querySelector('.main-header');

            let _headerUtilHeight = 0, _topBannerMessageHeight = 0, _mainHeaderHeight = 0;

            if(_topBannerMessage != null) _topBannerMessageHeight = _topBannerMessage.getBoundingClientRect().height;
            if(_headerUtils != null) _headerUtilHeight = _headerUtils.getBoundingClientRect().height;
            if(_mainHeader != null) _mainHeaderHeight = _mainHeader.getBoundingClientRect().height;

            let _topPos = _topBannerMessageHeight + _headerUtilHeight + _mainHeaderHeight;

            if(_megaWrapper != null) {
                // _megaWrapper.style.top = _topPos + 'px';
                let _megaMenuMaxHeight = 'calc(100vh - '+ (document.body.classList.contains("scroll-down") ? 88 : _topPos) +'px)';
                _megaWrapper.style.maxHeight = _megaMenuMaxHeight;
                let bleed = _megaWrapper.querySelector(".bleed.open");
                if(bleed)
                    bleed.style.maxHeight = _megaMenuMaxHeight;
            }
        } else {
            _megaWrapper.style.maxHeight = "100vh";
        }
    }

    function init() {
        GT.windowResizeFncList.desktopMegaMenuV2 = function(){
            closeSecondary();
            registerEvtForOpeningSecondary();
            setMegaPossition();
            promoteArticle();
        }

        registerEvtForOpeningSecondary();

        for(let i = 0; i < _closeMegaIcons.length; i++) {
            _closeMegaIcons[i].addEventListener("click", function() {
                if (document.querySelector('.nav-link.open'))
                    document.querySelector('.nav-link.open').focus();

                closeSecondary();
            });
            _closeMegaIcons[i].addEventListener('keydown', keypressNav);
        }
        
        let _featuredArticles = document.querySelectorAll('.mega-wrapper .article-tile');
        [].forEach.call(_featuredArticles, function(item) {
            item.addEventListener('keydown', keypressNav);
        });

        
        //Close mega nav when click outside mega menu
        if(GT.wWidth >= GT.breakPoints.tablet_lg) {
            clickOutsideMenu();

            if(GT.headerElm)
                GT.headerElm.addEventListener("mouseleave", function(){
                    if(GT.wWidth >= GT.breakPoints.tablet_lg)
                        closeSecondary();
                })
        }
    }

    function clickOutsideMenu() {
        document.addEventListener('mouseup', function(e) {
            if (!_megaWrapper.contains(e.target) && !e.target.classList.contains("nav-link--dropdown") && GT.wWidth >= GT.breakPoints.tablet_lg) {
                closeSecondary();
            }

            let langDropdownElm = document.querySelector(".header-lang");
            if (langDropdownElm && !langDropdownElm.contains(e.target)) {
                langDropdownElm.classList.remove("open")
            }
        });
    }
};

GT.TopBannerMessageForNoStickyHeader = function($elem) {
    var isStickyDisabled = !$('header').data('sticky');
    var header = $elem[0];

    $(document).ready(function() {
        if (isStickyDisabled) {
            window.onscroll = function() { handleTopBannderMessageOnMobile(); };
            window.onwheel = function() { handleTopBannderMessageOnMobile(); };
            window.onresize = function() { handleTopBannderMessageOnMobile(); };
            handleTopBannderMessageOnMobile();
        }
    });
    function isMessageTopBannerExist() {
        return $(header).find('.header-message-top-banner-wrapper').length;
    }
    function handleTopBannderMessageOnMobile() {
        if(isMessageTopBannerExist()) {
            if($(window).width() < 961){
                // if (window.pageYOffset > 0) {
                //     // $(header).find('.header-top').css('top', '0');
                //     $('.mobile').css('top', '63px');
                //     // $(header).find('.header-message-top-banner-wrapper').addClass('hidden-message');
                //     //recalculate header's height
                //     // if($(header).hasClass('campaign-header')) {
                //     //     $(header).css('height', '');
                //     // } else if ($(header).hasClass('main-header')){
                //     //     $(header).css('height', '64px');
                //     // }
                // } else if ($('html').css('position') != 'fixed') {
                //     var topBannerMessageHeight = $(header).find('.header-message-top-banner-wrapper').height();
                //     // $(header).find('.header-top').css('top', topBannerMessageHeight +'px');
                //     $('.mobile').css('top', topBannerMessageHeight+63 +'px');
                //     // $(header).find('.header-message-top-banner-wrapper').removeClass('hidden-message');
                //     //recalculate header's height
                //     // if($(header).hasClass('campaign-header')) {
                //     //     $(header).css('height', (topBannerMessageHeight) + 'px');
                //     // } else if ($(header).hasClass('main-header')){
                //     //     $(header).css('height', (topBannerMessageHeight+64) + 'px');
                //     // }
                // }
            } else {
                // reset when resize to desktop 
                // $(header).find('.header-message-top-banner-wrapper').removeClass('hidden-message');
                // $(header).find('.header-top').css('top', '0');
                // $(header).css('height', '');
                $('.insight-page').find('.breadcrumbs').css('padding-top', '30px');                
            }
        }
    }
}


GT.PrimaryNavV2 = function ($elem) {
    if(typeof isNav3 != "undefined") return;
    GT.triggerFnListAfterMainLogoLoaded.prepareSubMenuLink = prepareSubMenuLink;

    bindOutsideClick();
    initSearchBox();
    let submenuTimer = [];

    window.addEventListener("resize", e => {
        if(document.documentElement.classList.contains("opening-header-overlay")) 
            GT.Overlays.hideHeaderOverlay();
    })
    GT.windowResizeFncList.prepareSubMenuLink = function(){
        prepareSubMenuLink(true);
    }

    function initSearchBox() {
        let _globalSearch = document.querySelector('.global-search');
        let _searchButton = _globalSearch?.querySelector('.header-search__icon');
        let _closeButton = _globalSearch?.querySelector('.header-search__close');

        if(GT.isIOS()) {
            _searchButton?.addEventListener('touchstart', function(e) {
                let _this = this;
                // Close humberger menu when search box is openned
                let _humbergerMenu = document.querySelector('.menu-toggle');
                if(_humbergerMenu.classList.contains('open')) {
                    _humbergerMenu.click();
                }
                let onPageNav = document.querySelector(".onpage-navigation.expanded");
                if (onPageNav) {
                    document.firstElementChild.classList.remove("showing-overlay");
                    onPageNav.classList.remove("expanded");
                }

                setTimeout(function() {    
                    _globalSearch.classList.toggle('search-open');
                    _globalSearch.closest('.main-header').classList.toggle('search-open');
                    
                    if(_globalSearch.classList.contains('search-open')) {
                        GT.Overlays.showHeaderOverlay();
                    } else {
                        GT.Overlays.hideHeaderOverlay();
                    }

                    _this.addEventListener('touchend', function(e) {
                        let _searchField = _globalSearch.querySelector('input[name="q"]');
                        if(_globalSearch.classList.contains('search-open')) {
                            _searchField.setAttribute('autofocus', 'autofocus');
                            _searchField.focus();
                        } else {
                            _searchField.blur();
                        }
                    });
                }, 100);
            });
        } else {
            _searchButton?.addEventListener('click', function(e) {
                if(GT.isMobile() || GT.isMobileView()) {
                    // Close humberger menu when search box is openned
                    let _humbergerMenu = document.querySelector('.menu-toggle');
                    if(_humbergerMenu.classList.contains('open')) {
                        _humbergerMenu.click();
                    }
                    let onPageNav = document.querySelector(".onpage-navigation.expanded");
                    if (onPageNav) {
                        document.firstElementChild.classList.remove("showing-overlay");
                        onPageNav.classList.remove("expanded");
                    }

                    setTimeout(function() {
                        _globalSearch.classList.toggle('search-open');
                        _globalSearch.closest('.main-header').classList.toggle('search-open');
                        if(_globalSearch.classList.contains('search-open')) {
                            let _searchField = _globalSearch.querySelector('input[name="q"]');
                            _searchField.setAttribute('autofocus', 'autofocus');
                            _searchField.focus();
                            GT.Overlays.showHeaderOverlay();
                        } else
                            GT.Overlays.hideHeaderOverlay();
                    }, 100);
                }
            });
        }
        
        _searchButton?.addEventListener('click', function(e) {
            if(GT.isLargeDesktopView() || (!GT.isMobileView() && (e.currentTarget || e.target)?.closest(".global-search.open")))
                document.querySelector(".header-search__form")?.submit();
        })

        _closeButton?.addEventListener('click', function(e) {
            if(GT.isMobile() || GT.isMobileView()) {
                if(_globalSearch.classList.contains('search-open')) {
                    _globalSearch.classList.remove('search-open');
                    _globalSearch.closest('.main-header').classList.remove('search-open');
                    GT.Overlays.hideHeaderOverlay();
                }
            }
        })
    }

    function prepareSubMenuLink(forceRecheck) {
        let $menu = document.querySelector('.main-header');        
        let $menuItem = $menu.querySelectorAll('.level-1 > li:not(.menu-link):not(.hide-webex)');
        let appendMenuIndex = $menuItem.length;
        let lastMenuItem = null;
        
        let hasExtraItems = false,
            visibleElms = [];
        
        $menu.querySelectorAll('li.menu-link').forEach(item => {
            item.remove();
        })

        if(document.documentElement.classList.contains("opening-header-overlay")) 
            GT.Overlays.hideHeaderOverlay();

        GT.hideHyperLinkAnimation();
        
        $menuItem.forEach(function(el){
            el.classList.remove('extra');
        })

        GT.checkElmVisible('.level-1 > li:not(.menu-link):not(.hide-webex)', {
            callback: (e) => {
                visibleElms.push(e);
                submenuTimer.forEach(timer => {
                    clearTimeout(timer);
                })
                submenuTimer.push(setTimeout(() => {
                    let visibleElmsLength = visibleElms.length;
                    hasExtraItems = false,
                    lastMenuItem = null;
                    $menuItem.forEach(function(el, index){
                        if (index >= visibleElmsLength) {
                            if (index == appendMenuIndex - 1 && !lastMenuItem) {
                                lastMenuItem = el;
                            }
                            el.classList.add('extra');
                            hasExtraItems = true;
                        }
                    });
            
                    if (hasExtraItems || forceRecheck) {
                        appendSubMenu();
                    }
                }, 200));
            }
        });

        function appendSubMenu() {
            GT.hideHyperLinkAnimation();
            let extraMenuItemsHtml = '';
            $menu.querySelectorAll('li.extra').forEach(function(element){
                extraMenuItemsHtml += '<li>' + element.innerHTML + '</li>';
            });

            if(lastMenuItem) {
                lastMenuItem.insertAdjacentHTML("afterend", '<li class="menu-link"><button class="button-nav__link nav-link" aria-expanded="false" aria-label="'+ $menu.dataset.morelabel +'"><svg xmlns="http://www.w3.org/2000/svg" fill="currentColor" viewBox="0 0 100 100"><path d="M49.5,44.6c-2.9,0-5.3,2.4-5.3,5.3c0,2.9,2.4,5.3,5.3,5.3c2.9,0,5.3-2.4,5.3-5.3C54.8,47,52.4,44.6,49.5,44.6z"/><path d="M73.3,44.6c-2.9,0-5.3,2.4-5.3,5.3c0,2.9,2.4,5.3,5.3,5.3c2.9,0,5.3-2.4,5.3-5.3C78.6,47,76.2,44.6,73.3,44.6z"/><path d="M25.8,44.6c-2.9,0-5.4,2.4-5.4,5.3c0,2.9,2.4,5.3,5.4,5.3c2.9,0,5.4-2.4,5.4-5.3C31.1,47,28.7,44.6,25.8,44.6z"/></svg></button><div class="bs-hider"></div><ul class="sub-menu">' +
                extraMenuItemsHtml + '</ul></li>');
            }

            document.querySelectorAll('.sub-menu .nav-link--dropdown').forEach(function(navLink){
                navLink.classList.remove("nav-link--dropdown");
            });

            let menuLinkItem = document.querySelector('ul.list--mega.level-1 .menu-link');
            if(menuLinkItem) {
                menuLinkItem.addEventListener('click', function(e) {
                    let cursorElm = this.querySelector(".button-nav__link");
                    if (this.classList.contains('open')) {
                        if (e.target && !e.target.classList.contains('sub-menu'))
                            this.classList.remove('open');
                            cursorElm?.setAttribute("aria-expanded", false);
                            GT.Overlays.hideHeaderOverlay();
                    } else {
                        GT.hideHyperLinkAnimation();
                        this.classList.add('open');
                        cursorElm?.setAttribute("aria-expanded", true);
                        GT.Overlays.showHeaderOverlay();
                    }
                });
            }
        }
    }

    function bindOutsideClick() {
        $(document).on('click', function(e) {
            if (e.target) {
                $menuLink = $('ul.list--mega.level-1 .menu-link');
                if ($menuLink &&
                    !$(e.target).hasClass('sub-menu') &&
                    !$(e.target).hasClass('menu-link') &&
                    !$(e.target).hasClass('nav-link') &&
                    !$(e.target).hasClass('remove_file') &&
                    !(e.target.parentNode && e.target.parentNode.parentNode && e.target.parentNode.parentNode.className == "nav-link" && e.target.nodeName == "FONT")) {
                        $menuLink.removeClass('open');
                        //hide header overlay if click on header excepts serch input
                        if ( (e.target.id !== 'searchField') && !(document.querySelector('.global-search.search-open')) )
                            GT.Overlays.hideHeaderOverlay();
                }
            }
        });
    }
};

GT.SearchOverlayV2 = function($element) {
    let htmlElm = document.firstElementChild;
    let _globalSearch = document.querySelector('.global-search');
    let _searchForm = _globalSearch.querySelector('.header-search__form');
    let _searchOverlayModal = _globalSearch.querySelector('.search-overlay__modal');
    let _searchboxInput = _searchForm.querySelector('input[name="q"]');
    let _searchButton = _globalSearch.querySelector('.header-search__icon');
    let _submitButton = _globalSearch.querySelector('form.header-search__form input[name="search-submit__button"]');
    let _popularSearchResults = null;
    let _prevSuggestionResults = null;
    let _searchResultsContainer = _globalSearch.querySelector('.search-overlay__contents');
    let _closeButton = _globalSearch.querySelector('.close-button');
    let _isDisabledSearchOverlay = _searchboxInput.getAttribute('disabled-searchoverlay');
    let _isDisabledPopularSearch = _searchboxInput.getAttribute('disabled-popularsearch');
    let _isDisabledPreviousSearch = _searchboxInput.getAttribute('disable-previoussearch');
    let _userPreviousSearchesData = null;
    let _oldSearchKeyword = "";

    const _INPUT_START_TYPING_LENGTH = 3;
    const _MAX_PREVIOUS_SEARCH_ITEMS = 6;

    init();

    function processPreviousSearch() {

        if(isDisabledPreviousSearch()) return;

        let _searchPageUrl = _searchForm.getAttribute('action');
        let _previousSearchTitle = _searchOverlayModal.getAttribute('previous-search-title');
        let _userPreviousSearches = JSON.parse(localStorage.getItem('user_previous_searches'));
        // Show previous search section
        if(_userPreviousSearches != null && _userPreviousSearches.length > 0) {
            _userPreviousSearchesData = _userPreviousSearches;
            let _previousSearchHtml = '<div class="popular-search__container">';
            _previousSearchHtml     += '    <div class="gt-small-title heavy search-panel__title">' + _previousSearchTitle +'</div>';
            _previousSearchHtml     += '    <div class="search-panel__details">';
            _previousSearchHtml     += '        <ul class="search-suggestion__list">';
            
            [].forEach.call(_userPreviousSearches, function(_keyword) {
                _previousSearchHtml += '<li><a href="' + _searchPageUrl + '?q=' + encodeURIComponent(_keyword) + '" title="' + _keyword + '">' + _keyword.replace(/(<([^>]+)>)/gi, "") + '</a></li>';
            });

            _previousSearchHtml     += '        </ul>';
            _previousSearchHtml     += '    </div>';
            _previousSearchHtml     += '</div>';
            
            let _previousSearchesSection = document.getElementById('previous-search__container');
            if(_previousSearchesSection != null) {
                _previousSearchesSection.remove();
            }

            let _wrapPreviousSearchesHtml = document.createElement('div');
            _wrapPreviousSearchesHtml.id = 'previous-search__container';
            _wrapPreviousSearchesHtml.className = 'search-contents__container';

            _wrapPreviousSearchesHtml.innerHTML = _previousSearchHtml;
            _searchResultsContainer.insertBefore(_wrapPreviousSearchesHtml, _searchResultsContainer.firstChild);
        }
    }

    function initSearchOverlay() {       
        _searchboxInput.addEventListener('focus', function() {
            
            openGlobalSearch();

            toggleSearchModal(false);
            
            // Process to display user's previous searches
            processPreviousSearch();

            // Show modal in case second time user focus to search box when input length > 3
            let _searchKeyword = this.value.trim();
            if(_searchKeyword.length >= _INPUT_START_TYPING_LENGTH) {
                // Send ajax request if only input new keyword 
                if(_searchKeyword != _oldSearchKeyword.trim()) {
                    _oldSearchKeyword = _searchKeyword;
                    getSuggestionSearch(encodeURIComponent(_searchKeyword));
                } else {
                    if(_prevSuggestionResults) {
                        _searchResultsContainer.innerHTML = _prevSuggestionResults;
                    }
                    openGlobalSearch();
                    toggleSearchModal(true);
                }
            } else {
                if((_popularSearchResults != null && _popularSearchResults.length > 0)
                    || (_userPreviousSearchesData != null && _userPreviousSearchesData.length > 0)
                ) {
                    toggleSearchModal(true);
                }
            }

            if(isDisabledPopularSearch()) {
                // Hide search overlay modal in case input length < 3
                if((_searchboxInput.value.length < _INPUT_START_TYPING_LENGTH) 
                    && (_userPreviousSearchesData == null || _userPreviousSearchesData.length <= 0)) {

                    toggleSearchModal(false);
                }

                return;
            }

            // Show popular search on modal when first time user focus to search box
            if(_popularSearchResults == null || _popularSearchResults.length <= 0) {
                getPopularSearch();
            }
        });

        // Handle shift-tab keypress when outside of search box modal or search input text
        window.addEventListener('keydown', handleKey);
        function handleKey(e) {
            if (e.keyCode === 9) {
                let shift = e.shiftKey;
                if (shift) {
                    let _closeModal = false;
                    if (!_globalSearch.contains(e.target)) {
                        _closeModal = true;
                    } else {
                        if(e.target == _searchboxInput) {
                            _closeModal = true;
                        }
                    }

                    if(_closeModal) closeSearchOverlay();
                }
            }
        }
    };

    function isDisabledPreviousSearch() {
        return (!_isDisabledPreviousSearch || _isDisabledPreviousSearch.toLowerCase() == 'true');
    }

    function isDisabledPopularSearch() {
        return (!_isDisabledPopularSearch || _isDisabledPopularSearch.toLowerCase() == 'true');
    }

    function openGlobalSearch() {
        let _globalReach = document.querySelector('.global-reach');
        let _timeout = 0;
        if(_globalReach?.classList.contains('open')) {
            _globalReach?.classList.remove('open');
            htmlElm.classList.remove("global-reach--opening");
            _timeout = 300;
        }

        // Set timeout in case global reach is open.
        setTimeout(function() {
            if(!_globalSearch.classList.contains('open')) {
                _globalSearch.classList.add('open');
                _searchOverlayModal.removeAttribute('inert');
                htmlElm.classList.add('search-box__modal--open');
            }
            htmlElm.classList.add("global-search--opening");
        }, _timeout);
    }

    function toggleSearchModal(_isShow) {        
        if(_isShow) {
            _searchOverlayModal.classList.remove('hide');
            
            setTimeout(e => {
                GT.GTMGlobal.globalSearch();
            }, 100);
        } else {
            _searchOverlayModal.classList.add('hide');
        }
    }

    function escapeQueryChars(url) {
        return url
            .replace(/\s/gi, '+')
            .replace(/\%20/gi, '+')
            .replace(/\%(3C|3E)/gi, function (match, dec) {
                return encodeURI('%') + dec;
            });
    }

    function getPopularSearch() {
        let _popularSearchEndpoint = _searchboxInput.getAttribute('data-endpoint-popularsearch');
        if(_popularSearchEndpoint == null || _popularSearchEndpoint.length <= 0) return;
        _popularSearchEndpoint = escapeQueryChars(_popularSearchEndpoint);

        let recentIds = GT.Cookies.getCookie("recentIds");
        _popularSearchEndpoint += "&recentIds=" + recentIds;

        $.ajax({
            url: _popularSearchEndpoint,
            type: "get",
            success: function (data) {
                if(data.trim() == null || data.trim().length <= 0) {
                    if(!_userPreviousSearchesData) {
                        _searchOverlayModal.classList.add('hide');
                        toggleSearchModal(false);
                    } else {
                        toggleSearchModal(true);
                    }
                } else {
                    _searchOverlayModal.classList.remove('hide');
                    _popularSearchResults = data;
                    _searchResultsContainer.innerHTML = data;
                    processPreviousSearch();
                    linkKeyPressHandle();
                    toggleSearchModal(true);
                }
            },
            error: function (xhr) {
                console.error(xhr);
            }
        });
    }

    function getSuggestionSearch(_searchTerm) {
        let _suggestionSearchEndpoint = _searchboxInput.getAttribute('data-endpoint-searchsuggestion');

        if(_suggestionSearchEndpoint == null || _suggestionSearchEndpoint.length <= 0) return;

        _suggestionSearchEndpoint = _suggestionSearchEndpoint + _searchTerm;

        _suggestionSearchEndpoint = escapeQueryChars(_suggestionSearchEndpoint);
        $.ajax({
            url: _suggestionSearchEndpoint,
            type: "get",
            success: function (data) {
                if(data.trim() == null || data.trim().length <= 0) {
                    toggleSearchModal(false);
                } else {
                    _prevSuggestionResults = data;
                    _searchResultsContainer.innerHTML = data;
                    openGlobalSearch();
                    toggleSearchModal(true);
                }
            },
            error: function (xhr) {
                console.error(xhr);
            }
        });
    }

    function linkKeyPressHandle() {
        
        let searchOverlayLinks = document.querySelectorAll('.search-suggestion__list a, .search-results__list a');

        [].forEach.call(searchOverlayLinks, function(item) {
            let _parent = item.closest('#previous-search__container');
            if (!item.closest('li').nextElementSibling) {
                if (item.closest('.recently-visited__container'))
                    _parent = item.closest('.recently-visited__container');
                else if (item.closest('.search-contents__container.popular-search__container'))
                    _parent = item.closest('.search-contents__container.popular-search__container');

                if (!_parent.nextElementSibling) {
                    item.addEventListener('keydown', function(e) {
                        let keycode = e.keyCode || e.which;
                        if (9 == keycode) {
                            e.preventDefault();
                            _closeButton.focus();
                        }
                    });
                }
            }
        });
    }

    function init() {
        let _isDesktopView = GT.isTabletView();
        if(_isDesktopView) {
            if(!_isDisabledSearchOverlay || _isDisabledSearchOverlay.toLowerCase() == 'true') {
                return;
            }

            initSearchOverlay();

            document.addEventListener('mouseup', function(e) {
                if (!_globalSearch.contains(e.target)) {
                    if(document.activeElement != _searchboxInput) {
                        closeSearchOverlay();
                    }
                }
            });

            _globalSearch.addEventListener("keydown", (e) => {
                if(e.key == "Escape") {
                    if(document.querySelector('.global-search.open')) {
                        GT.isScreenReader = true;
                        closeAction();
                    }
                }
            })

            _searchboxInput.addEventListener('input', GT.debounce(function(){
                searchboxOnChange();
            }, 500));

            _searchButton.addEventListener('click', function(e) {
                if(_searchboxInput.value.length <= 0) {
                    _searchboxInput.focus();
                    return;
                }
                _submitButton.click();
            });



            function handleFirstFocusableElm() {
                let _firstFocusable = GT.getFirstFocusableVisible();

                if(!_firstFocusable.dataset.initialized)
                    _firstFocusable.addEventListener('keydown', function(e) {
                        let _keycode = e.keyCode || e.which;
                        if (9 == _keycode && e.shiftKey) {
                            e.preventDefault();
                            document.querySelector('#searchField').focus();
                        }
                    });

                _firstFocusable.dataset.initialized = true;
                // #175120 - Remove focusing on first element when user close the Global search when scrolling the page
                if(window.scrollY < 10)
                    setTimeout(function() {
                        _firstFocusable.focus();
                    },500);
            }

            function closeAction(){
                closeSearchOverlay();
                handleFirstFocusableElm();
            }

            _closeButton.addEventListener('click', closeAction);
            _closeButton.addEventListener('keypress', function(e){
                if(e.key == "Enter")
                    closeAction();
            });


            _searchForm.addEventListener('submit', e => {

                if(isDisabledPreviousSearch()) return;

                let _searchkeyword = _searchboxInput.value;
                
                if(_searchkeyword == null || _searchkeyword.trim().length <= 0) {
                    return false;
                }
                               
                //Process to save search keyword into local stograde before submit search form
                GT.processSearchKeywordBeforeSubmit(_searchkeyword.trim(), _userPreviousSearchesData, _MAX_PREVIOUS_SEARCH_ITEMS);
                dataLayer.push({ 'event': 'global_search', 'eventAction': 'navigation_search', 'eventLabel': _searchkeyword });               
            });
        }
    }

    function searchboxOnChange(){
        let _inputValue = _searchboxInput.value.trim();
        if(_inputValue.length >= _INPUT_START_TYPING_LENGTH) {
            getSuggestionSearch(encodeURIComponent(_inputValue));
            _oldSearchKeyword = _inputValue;
        } else {
            if((isDisabledPopularSearch() || _popularSearchResults == null) && (_userPreviousSearchesData == null || _userPreviousSearchesData.length <= 0)) {
                toggleSearchModal(false);
            } else {
                _searchResultsContainer.innerHTML = _popularSearchResults;
                
                // Add previous search section
                processPreviousSearch();
                toggleSearchModal(true);
            }
        }
    }

    function closeSearchOverlay() {
        _globalSearch.classList.remove('open');
        htmlElm.classList.remove("global-search--opening");
        _searchOverlayModal.setAttribute('inert', 'true');
        setTimeout(function() {
            htmlElm.classList.remove('search-box__modal--open');
        }, 500);
    }
};

GT.UtilityNavigation = function (elem) {
    let me = this;
    me.init = function () {

        function pressESCToClose(e){
            if(e.key == "Escape") {
                langDropdown.btnToggle.focus();
                langDropdown.btnToggle.click();
            }

            if(e.key == "Tab" && e.shiftKey && (e.target || e.currentTarget).classList.contains("header-lang__select")) {
                if(langDropdown.itemsLength) {
                    e.preventDefault();
                    langDropdown.items[langDropdown.itemsLength - 1].focus();
                }
            }
        }


        let langDropdown = {
            btnToggle: document.querySelector('.header-lang__select'),
            items: document.querySelectorAll('.header-lang__dropdown a'),
            doToggle: function() {
                let headerLangBtn = document.querySelector('.header-lang');
                
                headerLangBtn.classList.toggle('open');
                if ( headerLangBtn.classList.contains('open') ) {
                    GT.hideHyperLinkAnimation();
                    this.btnToggle.setAttribute('aria-expanded', 'true');
                    window.addEventListener("keydown", pressESCToClose);
                } else {
                    this.btnToggle.setAttribute('aria-expanded', 'false');
                    window.removeEventListener("keydown", pressESCToClose);
                }
            }
        };

        if(langDropdown.btnToggle) {
            langDropdown.itemsLength = langDropdown.items.length;
            langDropdown.btnToggle.addEventListener('click', function() { 
                langDropdown.doToggle(); 
            });

            if(langDropdown.itemsLength) {
                langDropdown.items[langDropdown.itemsLength - 1].addEventListener("keydown", e => {
                    if(e.key == "Tab" && !e.shiftKey) {
                        e.preventDefault();
                        langDropdown.btnToggle.focus();
                    }
                })
            }
        }
    }
    me.init();
};
GT.StickyHeaderV2 = function ($elem) {
    var allowSticky = allowStickyHeaderV2();
    var isIE = GT.isIE();
    var onT45 = isT45V2();
    let topHeaderWrapper,
        isAnimating = false,
        scrollTimers = [],
        lastScrollTop = 0,
        isScrollDown = null,
        htmlElm = document.documentElement;

    if (allowSticky) {
        var header = document.querySelector('header');
        var $stickyHeaderContainer = $(header).find('.header-top');
        var $headerLang = $stickyHeaderContainer.find('.header__lang');
        var $globalReach = $(header).find('.global-reach');
        var $globalReachToggle = $(header).find('.header__global-reach-toggle');
        var $searchIcon = $stickyHeaderContainer.find('.header__search button.icon-link');
        var $dropdownArrow = $stickyHeaderContainer.find('i.lang-dropdown-arrow');
        var headerOriginalHeight = undefined;
        var topBannerMSGElm = document.querySelector(".header-message-top-banner-wrapper"),
            headerElmHeight = 0;
        var sticky = 0;   

        var isPageTooShort = checkIfPageTooShort();
        if (!isPageTooShort) {
            GT.listFunctionsTriggerInScrollEvent.doStickyHeader = doSticky;
            doSticky();
        } else {
            $('.mega__level--2').unwrap();
        }
        $(window).on('user-translate', onUserTranslate);
        $(window).on('resize', GT.debounce(function(){
            onUserResize();
        }, 200));

        bindOutsideClick();
        prepareGlobalReach();
        prepareLangDropdown();
    }

    function isMessageTopBannerExist() {
        return $(header).find('.header-message-top-banner-wrapper').length;
    }

    function isMobileWidth() {
        return GT.wWidth < 961;
    }
    
    function doSticky() {
        if (isMobileWidth() || htmlElm.classList.contains("global-reach--opening")) {
            return;
        } else {           
            let pageYOffset = htmlElm.scrollTop;

            if(!isAnimating) {
                if (pageYOffset > lastScrollTop)
                    isScrollDown = true;
                else
                    isScrollDown  = false;
            }

            if(!isAnimating) {
                if (pageYOffset > 10){
                    if (topBannerMSGElm && isIE) topHeaderWrapper.style.paddingTop = "0";
                    if (!header.classList.contains('animate')) header.classList.add("animate");
                    if (!header.classList.contains('sticky')) {
                        header.classList.add("sticky");
                        document.body.classList.add("header-is-sticking");
                        
                        if (isIE) header.style.height = "80px";
                        isAnimating = true;
                        setTimeout(function(){
                            isAnimating = false;
                        }, 200)
                    }
                } else if (pageYOffset <= 0 && !isScrollDown && !isAnimating && header.classList.contains("sticky")){
                    header.classList.remove("sticky");
                    document.body.classList.remove("header-is-sticking");
                    if (topBannerMSGElm && isIE) topHeaderWrapper.style.paddingTop = "32px";
                    if (isIE) header.style.height = headerElmHeight + "px";
                    isAnimating = false;
                }
            } 
            
            if(scrollTimers.length) {
                scrollTimers.forEach(function(timer){
                    clearTimeout(timer);
                })
                scrollTimers = [];
            }

            let tmpTimer = setTimeout(function(){
                if(header.classList.contains('sticky') && pageYOffset <= 1) {
                    htmlElm.scrollTop =  1;
                }
            }, 100);
            scrollTimers.push(tmpTimer);
            lastScrollTop = pageYOffset <= 0 ? 0 : pageYOffset; // For Mobile or negative scrolling
            
            if ($menuLink) {
                $menuLink.removeClass('open')
            }
            if ($headerLang.length > 0) {
                $stickyHeaderContainer.css('overflow', 'hidden');
                $headerLang.removeClass('open');
                $originalLogo.removeClass('hidden');
            }
        }
    }

    function onUserTranslate() {
        setTimeout(function() {
            checkIfPageTooShort();
        }, 1000);
    }

    function onUserResize() {
        setTimeout(function() {
            var allowSticky = allowStickyHeaderV2();
            if (allowSticky) {
                checkIfPageTooShort();

                header.style.transform = "translateY(0)";
                if(isMobileWidth()) {
                    header.classList.remove("sticky");
                    document.body.classList.remove("header-is-sticking");
                    
                    if(header.classList.contains('will-change-to-insight-header')) {
                        header.classList.remove("insight-sticky");
                        header.classList.remove("insight-header");
                    } else {
                        header.classList.remove("sticky");
                    }

                } else {
                    doSticky();
                }
            }

        }, 100);
    }

    function prepareLangDropdown() {
        if ($headerLang.length === 0) {
            $(header).addClass('no-language');
            return;
        }
        var $languageLinks = $headerLang.find('.site-language').not('.active');
        if ($languageLinks.length === 0) {
            $(header).addClass('no-language');
            return;
        }
        var $activeLang = $headerLang.find('.header-lang__dropdown');
        if($activeLang.hasClass('active')) {
            var languageLinkHtml = '';
            $.each($languageLinks, function(index, element) {
                languageLinkHtml += '<li>' + element.outerHTML + '</li>';
            });
            $activeLang.after('<ul class="lang-dropdown notranslate">' + languageLinkHtml + '</ul>')
            $activeLang.on('click', function() {
                GT.hideHyperLinkAnimation();
                toggleLangDropdown();
            });
        }
    }

    function prepareGlobalReach() {
        if ($globalReach.length > 0) {
            if ($dropdownArrow.length > 0) {
                $dropdownArrow.on('click', function(e) {
                    if ($headerLang.length > 0) {
                        toggleLangDropdown();
                    }
                });
            }
        }
    }

    function bindOutsideClick() {
        $(document).on('click', function(e) {
            if (e.target) {
                if ($menuLink &&
                    !$(e.target).hasClass('sub-menu') &&
                    !$(e.target).hasClass('menu-link') &&
                    !$(e.target).hasClass('nav-link') &&
                    !$(e.target).hasClass('remove_file') &&
                    !(e.target.parentNode && e.target.parentNode.parentNode && e.target.parentNode.parentNode.className == "nav-link" && e.target.nodeName == "FONT")) {
                        $menuLink.removeClass('open');
                }

                if ($headerLang.length > 0 && !$(e.target).hasClass('.header__lang') &&
                    !$(e.target).closest('.header__lang').length > 0 && !$(e.target).hasClass('ic-lang-dropdown-arrow')) {
                    $headerLang.removeClass('open');
                }
            }
        });
    }

    function toggleLangDropdown() {
        if ( ($(header).hasClass('sticky')) || (onT45) ) {
            if ($headerLang.hasClass('open')) {
                $headerLang.removeClass('open');
                $stickyHeaderContainer.css('overflow', 'hidden');
            } else {
                $originalLogo.addClass('hidden');
                $stickyHeaderContainer.css('overflow', 'visible');
                $headerLang.addClass('open');
            }
        }
    }

    function bindTabEvent(lastMenuItem) {
        var $lastMenuItem = lastMenuItem;
        var $subMenuItems = $lastMenuItem.find('.sub-menu a');
        var $nav = $(header).find('nav');
        $nav.on('keydown', function(e) {
            if (e.keyCode == 9 && !e.shiftKey) {
                var activeEl = document.activeElement;
                if (activeEl && ($(activeEl).closest('nav').length === 0 || $(activeEl).hasClass('mega')) &&
                    $(activeEl).closest('.header__utils').length === 0) {
                    e.preventDefault();
                    var $firstLink = $nav.find('a.nav-link').first();
                    var $miniLogo = $('.mini-logo');
                    $firstLink.off('keydown');
                    $miniLogo.on('keydown', function(e2) {
                        if (e2.keyCode == 9 && !e2.shiftKey) {
                            e2.preventDefault();
                            $firstLink.focus();
                        }
                    });
                    $firstLink.off('keydown');
                    $firstLink.on('keydown', function(e3) {
                        if (e3.shiftKey && e3.keyCode == 9) {
                            e3.preventDefault();
                            $miniLogo.focus();
                        }
                    });
                    $miniLogo.focus();
                }
            }
        });
        $lastMenuItem.on('keydown', function(e) {
            if ($(e.target).closest('.sub-menu').length !== 0) return;
            if (e.keyCode == 9 && !e.shiftKey && $(header).hasClass('sticky')) {
                e.preventDefault();
                if (!$(this).hasClass('open')) {
                    if ($loginLink.length > 0) {
                        $loginLink.focus();
                        return;
                    } else if ($headerLang.length > 0) {
                        $headerLang.find('span.active').focus();
                        return;
                    } else if ($globalReachToggle.length > 0) {
                        var $button = $globalReachToggle.find('.global-reach__toggle');
                        $button.focus();
                        return;
                    }
                } else {
                    var $subMenuLink = $subMenuItems.first();
                    $subMenuLink.focus();
                }
            }
        });
        if ($subMenuItems.length > 0) {
            $subMenuItems.on('keydown', function(e) {
                if (!e.shiftKey && e.keyCode == 9) {
                    e.preventDefault();
                    var index = $subMenuItems.index($(this));
                    if (index !== $subMenuItems.length - 1) {
                        $subMenuItems.eq(index + 1).focus();
                    } else {
                        if ($loginLink.length > 0) $loginLink.focus();
                        else if ($headerLang.length > 0) $headerLang.focus();
                        else if ($globalReachToggle.length > 0) {
                            var $button = $globalReachToggle.find('.global-reach__toggle');
                            $button.focus();
                        }
                    }
                }
            });
        }
        if ($loginLink.length > 0) {
            $loginLink.on('keydown', function(e) {
                if (e.shiftKey && e.keyCode == 9 && $(header).hasClass('sticky')) {
                    e.preventDefault();
                    if ($lastMenuItem.length > 0) {
                        var $link = $lastMenuItem.find('a');
                        var $span = $lastMenuItem.find('span');
                        if ($link.length > 0) $link.focus();
                        if ($span.length > 0) $span.focus();
                    }
                }
                if (e.keyCode == 9 && !e.shiftKey && !$(header).hasClass('sticky')) {
                    if ($headerLang.length > 0) {
                        e.preventDefault();
                        var $languageLinks = $headerLang.find('.site-language');
                        for (var i = 0; i < $languageLinks.length; i++) {
                            var languageLink = $languageLinks.eq(i);
                            if (!languageLink.parent().parent().hasClass('lang-dropdown')) {
                                languageLink.focus();
                                languageLink.off('keydown');
                                languageLink.on('keydown', function(e2) {
                                    if (e2.shiftKey && e2.keyCode == 9 && !$(header).hasClass('sticky')) {
                                        e2.preventDefault();
                                        $loginLink.focus();
                                    }
                                });
                                break;
                            }
                        }

                    }
                }
            });
        }

        if ($headerLang.length > 0) {
            var $headerLangActive = $headerLang.find('span.active');
            $headerLangActive.on('keydown', function(e) {
                if (e.keyCode == 9 && $(header).hasClass('sticky')) {
                    e.preventDefault();
                    if (e.shiftKey) {
                        if ($loginLink.length > 0) {
                            $loginLink.focus();
                        } else if ($lastMenuItem.length > 0) {
                            var $link = $lastMenuItem.find('a');
                            var $span = $lastMenuItem.find('span');
                            if ($link.length > 0) $link.focus();
                            if ($span.length > 0) $span.focus();
                        }
                    } else {
                        if (!$headerLang.hasClass('open')) {
                            $globalReachToggle.find('.global-reach__toggle').focus();
                        } else {
                            var $firstLang = $headerLang.find('ul.lang-dropdown a').first();
                            var $lastLang = $headerLang.find('ul.lang-dropdown a').last();
                            $firstLang.focus();
                            $lastLang.on('keydown', function(e2) {
                                if (e2.keyCode == 9 && !e2.shiftKey) {
                                    e2.preventDefault();
                                    $globalReachToggle.find('.global-reach__toggle').focus();
                                }
                            });
                        }
                    }
                }
            });
        }

        if ($globalReachToggle.length > 0) {
            var $button = $globalReachToggle.find('.global-reach__toggle');
            $button.on('keydown', function(e) {
                if ( ( e.keyCode == 9 && $(header).hasClass('sticky') ) || ( e.keyCode == 9 && onT45) ) {
                    if (e.shiftKey) {
                        e.preventDefault();
                        if ($headerLang.length > 0) {
                            if (!$headerLang.hasClass('open')) {
                                $headerLang.find('span.active').focus();
                            } else {
                                var $lastLang = $headerLang.find('ul.lang-dropdown a').last();
                                $lastLang.focus();
                            }
                        } else if ($loginLink.length > 0) {
                            $loginLink.focus();
                        } else if ($lastMenuItem.hasClass('open')) {
                            $lastMenuItem.find('.sub-menu a').last().focus();
                        } else {
                            $lastMenuItem.focus();
                        }
                    }
                }
            });
        }

        if ($searchIcon.length > 0) {
            $searchIcon.on('keydown', function(e) {
                if (e.keyCode == 9 && !e.shiftKey && $(header).hasClass('sticky')) {
                    e.preventDefault();
                    focusNextElement();
                }
            });
        }

    }

    function isRTL() {
        return $('body').hasClass('RTL');
    }

    function appendStyleDom(style, id) {
        if (!id) id = new Date().getTime();
        else {
            var $existingStyle = $('#' + id);
            if ($existingStyle.length > 0) $existingStyle.remove();
        }
        var styleDom = $('<style id="' + id + '">' + style + '</style>');
        $('body').append(styleDom);
    }

    function checkIfPageTooShort() {
        var id = 'gt-head';
        var $existingStyle = $('#' + id);
        if ($existingStyle.length > 0) $existingStyle.remove();
        var documentHeight = $(document).height();
        var windowHeight = window.screen.height;
        var $topWrapper = $(header).find('.header-top-wrapper');
        headerOriginalHeight = $topWrapper.height();

        if (headerOriginalHeight < 192) headerOriginalHeight = 192;
        else if (headerOriginalHeight > 200 && headerOriginalHeight < 257) headerOriginalHeight = 256;
        var headerNewHeight = 80;
        if (allowSticky) {
            var style = '.mega__level--1 .nav-link[data-sub="true"]:hover:before {height: ' + $(header).find('.mega__level--1').height() + 'px}';
            if(isIE)
                style += ' header .mega-wrapper {top: ' + headerOriginalHeight + 'px;}';
            appendStyleDom(style, id);
        }

        if(document.querySelector(".event-registration-page-v2"))
            return false;
        else
            return documentHeight - (headerOriginalHeight - headerNewHeight) <= windowHeight;
    }

    function focusNextElement() {
        var focussableElements = 'a:not([disabled]), button:not([disabled]), input[type=text]:not([disabled]), [tabindex]:not([disabled]):not([tabindex="-1"])';
        if (document.activeElement) {
            var focussable = Array.prototype.filter.call(document.querySelectorAll(focussableElements),
                function(element) {
                    return element.offsetWidth > 0 || element.offsetHeight > 0 || element === document.activeElement
                });
            var index = focussable.indexOf(document.activeElement);
            while (index < focussable.length - 1) {
                var nextElement = $(focussable[index + 1]);
                if (nextElement.closest('nav').length == 0) {
                    focussable[index + 1].focus();
                    break;
                }
                index++;
            }
        }
    }
};

function allowStickyHeaderV2() {
    var enableSticky = $('.main-header').data('sticky') || $('.insight-page header').hasClass("insight-sticky");
    return enableSticky;
}

function isT45V2() {
    return document.querySelector(".insight-page header") && document.querySelector(".insight-page header").classList.contains("insight-sticky");
}

GT.Reach = function() {
    let htmlElm = document.firstElementChild;
    let globalReachElm = htmlElm.querySelector(".global-reach");
    if (!globalReachElm) return;
    let isInited = false;
    let globalReachToggleBtn = GT.headerElm.querySelector(".global-reach__toggle");
    let globalReachTabElms = globalReachElm.querySelectorAll('.reach-region-selector li');
    let isDesktop = GT.isDesktopView();
        
    if(typeof isNav3 == "undefined") {
        globalReachToggleBtn = GT.isMobileView() ? GT.headerElm.querySelector(".global-toggle-m") : GT.headerElm.querySelector(".global-reach__toggle");
    }

    function disableScroll(isDisable){
        if(GT.isTabletView()) {
            if(isDisable) {
                typeof isNav3 != "undefined" && GT.Overlays.showHeaderOverlay();
                htmlElm.classList.add("global-reach--opening");
                GT.headerElm.querySelector(".menu-link.open")?.classList.remove("open");
            } else {
                GT.preventHeaderFromFlickeringWhileBodyHeightIsChanging();
                GT.headerElm.style.setProperty("--globalreach-height", 0);
                GT.headerElm.classList.remove("trigger-animation");
                htmlElm.classList.remove("global-reach--opening");
                setTimeout(() => {
                    typeof isNav3 != "undefined" && GT.Overlays.hideHeaderOverlay();
                }, 350);
            }
        }

        if(!isDisable)
            setTimeout(e => {
                globalReachToggleBtn?.focus();
            }, 1000)
    }

    function calcActivatedTabHeight() {
        GT.headerElm.style.setProperty("--globalreach-height", globalReachElm.querySelector(".global-reach__list.active")?.offsetHeight + "px");
    }

    function initReachToggle() {
        if(globalReachToggleBtn.dataset.inited)
            return;

        globalReachToggleBtn.dataset.inited = true;

        function pressESCToClose(e){
            if(e.key == "Escape") {
                globalReachToggleBtn.click();
            }
        }
        
        const globalReachHeadTitle = globalReachElm.querySelector('.global-reach__head .title');

        globalReachHeadTitle?.addEventListener('keydown', tabify);

        globalReachToggleBtn.addEventListener('click', function(e) {
            e.preventDefault();
            // if ($(e.target).hasClass('lang-dropdown-arrow')) {
            //     e.stopPropagation();
            //     return;
            // }
            
            let closeMegaNav2Btn = document.querySelector(".close-mega__menu");
            if(GT.isNav2 && closeMegaNav2Btn && GT.wWidth >= GT.breakPoints.tablet_lg) {
                closeMegaNav2Btn.click();
            }

            if (globalReachElm.classList.contains("open")) {
                globalReachElm.classList.remove("open");
                globalReachToggleBtn.setAttribute("aria-expanded", false);
                globalReachElm.setAttribute("aria-hidden", true);
                disableScroll();
                window.removeEventListener("keydown", pressESCToClose);
            } else {
                window.addEventListener("keydown", pressESCToClose);
                globalReachElm.classList.add("open");
                globalReachElm.removeAttribute("aria-hidden");
                globalReachToggleBtn.setAttribute("aria-expanded", true);
                
                globalReachTabElms.forEach(tabItem => {
                    if(!isInited) {
                        tabItem.addEventListener("click", tabify);
                        tabItem.addEventListener("keydown", tabify);
                    }
                    
                    if(GT.isMobileCached) {
                        tabItem.setAttribute("tabindex", 0);
                        tabItem.setAttribute("aria-expanded", false);
                    } else {
                        tabItem.setAttribute("role", "tab");
                        tabItem.setAttribute("aria-selected", false);
                        tabItem.removeAttribute("aria-expanded");
                        tabItem.setAttribute("tabindex", -1);

                        if(tabItem.classList.contains("active")) {
                            tabItem.setAttribute("tabindex", 0);
                            tabItem.setAttribute("aria-selected", true);
                            tabItem.closest("ul").setAttribute("role", "tablist");
                            if(!isInited) {
                                setTimeout(() => {
                                    TabPanelActionHandler(tabItem.closest("ul"));
                                }, 500);
                            }
                        }
                    }
                })


                if(!isInited) {
                    GT.headerElm.classList.add("fetching");
                    isInited = true;
                    
                    globalReachElm.querySelector('.global-reach__close').addEventListener("click", () => {
                        globalReachElm.classList.remove("open");
                        globalReachElm.setAttribute("aria-hidden", true);
                        globalReachToggleBtn.setAttribute("aria-expanded", false);
                        disableScroll();
                    });


                    httpService = new HttpService();
                    httpService.getHtmlContent(globalReachLink, null, {"Content-type": "application/x-www-form-urlencoded"}, true).then(response => {

                        let globalReachRegionsMoileLV1Elm = document.querySelector(".mobile__global--level-1 .list");
                        if(globalReachRegionsMoileLV1Elm)
                            globalReachRegionsMoileLV1Elm.classList.remove("hide");

                        globalReachElm.querySelector("#global-reach-regions").insertAdjacentHTML("beforeend", `
                            <div class="translate-animation-item slow">
                                <div class="global-reach__content">
                                    ${response}
                                </div>
                            </div>
                        `);
                        GT.hideHyperLinkAnimation();
                        calcActivatedTabHeight();
                        setTimeout(function() {
                            GT.headerElm.classList.add("trigger-animation");
                        }, 100);
                        GT.GTMGlobal.megaMenu();
                    })
                    .catch((rej) => {
                        isInited = false;
                    })
                    .finally(() => {
                        GT.headerElm.classList.remove("fetching");
                    });

                } else {
                    GT.headerElm.classList.add("trigger-animation");
                    calcActivatedTabHeight();
                }

                disableScroll(true);
                setTimeout(function() {
                    globalReachElm.querySelector(".global-reach__head a")?.focus();
                    linkHandle();
                }, 1000);
            }
        });

    }


    function tabify(e) {
        if (e.key != "Tab") {
            e.preventDefault();
        }

        if (e.key == "Tab" && isDesktop) {
            const target = e.target;
            const activeLinks = globalReachElm.querySelectorAll('.global-reach__list.active .local-site-link');
            const lastActiveLink = activeLinks[activeLinks.length - 1];

            if (e.shiftKey && target.closest('.global-reach__head') && lastActiveLink) {
                e.preventDefault();
                lastActiveLink.focus();
            }
        }

        if (!e.keyCode || e.key == "Enter" || e.key == " ") {
            GT.hideHyperLinkAnimation();
            const currentTab = e.target,
                activeEl = currentTab.dataset.tab;

            if (!currentTab.classList.contains("active")) {
                globalReachTabElms.forEach(tabItem => {
                    tabItem.setAttribute("aria-selected", false);
                })

                if(!GT.isMobileCached) {
                    globalReachTabElms.forEach(tabItem => {
                        tabItem.removeAttribute("aria-expanded");
                        tabItem.setAttribute("tabindex", -1);
                    })
                    currentTab.setAttribute("tabindex", 0);
                    currentTab.setAttribute("aria-selected", true);
                } else {
                    globalReachTabElms.forEach(tabItem => {
                        tabItem.setAttribute("aria-expanded", false);
                    })
                    currentTab.setAttribute("aria-expanded", true);
                }

                setTimeout(() => {
                    globalReachTabElms.forEach(tabItem => {
                        tabItem.classList.remove("active");
                    })
                    currentTab.classList.add("active");

                    document.querySelectorAll(".global-reach .global-reach__list").forEach(listPanelItem => {
                        listPanelItem.classList.remove("active");
                        
                        if (listPanelItem.classList.contains(activeEl)) {
                            listPanelItem.classList.add("active");
                            calcActivatedTabHeight();
                            if(GT.isScreenReader && GT.isMobileCached)
                                setTimeout(e => {
                                    document.querySelector(".global-reach__list.active a")?.focus();
                                }, 500)
                        }
                    })
                }, GT.isMobileCached ? 500 : 0)
            }
        }
    }

    function linkHandle() {
        document.querySelectorAll('.global-reach__list a').forEach(item => {
            let parentElm = item.closest('li');
            item.addEventListener('keydown', function(e) {
                if (e.key == 'Tab' && !e.shiftKey && !parentElm.nextElementSibling) {
                    e.preventDefault();
                    document.querySelector('.global-reach__head .title').focus();
                }
            });
        });
    }

    initReachToggle();
    
    GT.windowResizeFncList.globalReach = function(){
        if(htmlElm.classList.contains("global-reach--opening"))
            globalReachToggleBtn.click();

        if(typeof isNav3 == "undefined") {
            globalReachToggleBtn = GT.isMobileView() ? GT.headerElm.querySelector(".global-toggle-m") : GT.headerElm.querySelector(".global-reach__toggle");
        }
    }
};

GT.domContentLoadedFncList.push(function(){
    GT.Reach();
})
GT.isNav2 = true;

GT.Initiator = function (__object) {
    // if test passed (selector present on site) - fire function form current object on obj context (passing as argument selector and arguments or empty)
    var __$tmp = __object.settings && __object.settings.nojquery ? document.querySelectorAll(__object.test) : $(__object.test);
    try {
        if (__$tmp.length && __object.constr)
            new __object.constr(__$tmp, __object);
    } catch (exp) {
        console.warn(exp);
    }
};

GT.domContentLoadedFncList.push(function(){

    GT.Cookies = new GTCookies();
    GT.Cookies.cookieNotify();

    GT.GTObjects = [
        { constr: GT.StickyHeaderV2, test: '.main-header', settings: { }},
        { constr: GT.PrimaryNavV2, test: '.header-menu', settings: { } },
        { constr: GT.FakeHyperlink, test: '[data-anchor]' },
        { constr: GT.SearchOverlayV2, test: '.global-search' },
        { constr: GT.MegaNavigationV2, test: '.mega-wrapper', settings: { } },
        { constr: GT.MobileNavigationV2, test: '.menu-toggle', settings: { } },
        { constr: GT.UtilityNavigation, test: '.header-utils', settings: { } }
    ];

    if(typeof isV1GT == "undefined") 
        GT.GTObjects.push({ constr: GT.Reach, test: '.global-reach' });

    GT.GTObjects.map(GT.Initiator);
});
GT.freezeVp = function (e) {
    e.preventDefault();
};


window.addEventListener("DOMContentLoaded", function(){
    GT.headerElm = document.querySelector("header");
    if(GT.headerElm)
        GT.topBannerMsgElm = document.querySelector(".header-message-top-banner-wrapper");
    
    GT.mainHeaderElm = document.querySelector(".main-header");
    GT.wHeight = window.innerHeight;
    GT.wWidth = window.innerWidth;
    GT.bodyWidth = document.body.clientWidth;
    GT.scrollbarWidth = GT.wWidth - GT.bodyWidth;
    document.documentElement.style.setProperty('--scrollbar-width', GT.scrollbarWidth + 'px');
    document.documentElement.style.setProperty('--window-height', GT.wHeight + 'px');


    function triggerFunctionsAfterMainLogoLoaded(){
        setTimeout(function() {
            Object.keys(GT.triggerFnListAfterMainLogoLoaded).forEach(function(k) {
                GT.triggerFnListAfterMainLogoLoaded[k]();
            })
            setTimeout(function(){
                if(GT.headerElm) {
                    GT.headerElmHeight = GT.headerElm.clientHeight;
                    document.documentElement.style.setProperty('--header-height', GT.headerElmHeight + 'px');
                }

                if(GT.scrollTop() < 100 && !location.hash)
                    window.scrollTo(0,0);
            }, 50)
        })
    }

    let desktopLogo = document.querySelector(".desktop-logo img");
    if(desktopLogo) {
        desktopLogo.onload = function(){
            triggerFunctionsAfterMainLogoLoaded();
        }
        desktopLogo.onerror = function(){
            triggerFunctionsAfterMainLogoLoaded();
        }
        if(desktopLogo.complete) {
            triggerFunctionsAfterMainLogoLoaded();
        }
    } else
        triggerFunctionsAfterMainLogoLoaded();

    if(GT.topBannerMsgElm) {
        document.documentElement.style.setProperty('--top-banner-msg-height', GT.topBannerMsgElm.clientHeight + 'px');
    }

    if(GT.mainHeaderElm) {
        GT.mainHeaderElmHeight = GT.mainHeaderElm.clientHeight;
        document.documentElement.style.setProperty('--main-header-height', GT.mainHeaderElmHeight + 'px');
    }

	GT.announceArea = document.querySelector(".announce-area");
    
	initTabPanelActionHandler();
    
    if(typeof isV1GT == "undefined") {
        GT.isTouchDevice = GT.isTouchDevice();
        GT.domContentLoadedFncList.forEach(function(fnc){
            try {
                fnc();
            } catch (e) {
                console.log(e);
            }
        })
    }
});

let isOrientationChange = false;
if(window.screen.orientation)
    window.screen.orientation.addEventListener('change', function(){
        isOrientationChange = true;
    });
else
    window.addEventListener("orientationchange", function() {
        isOrientationChange = true;
    });

GT.recalculateHeaderHeight = function(){
    setTimeout(function(){
        if(GT.headerElm) {
			GT.stickyHeaderOffsetTop = GT.headerElm.firstElementChild.offsetHeight - (GT.isMobileView() ? 64 : 88);
            GT.headerElmHeight = GT.headerElm.clientHeight;
            document.documentElement.style.setProperty('--header-height', GT.headerElmHeight + 'px');
        }

        if(GT.topBannerMsgElm) {
            GT.topBannerMsgElmHeight = GT.topBannerMsgElm.clientHeight;
            document.documentElement.style.setProperty('--top-banner-msg-height', GT.topBannerMsgElmHeight + 'px');
        }

        if(GT.mainHeaderElm) {
            GT.mainHeaderElmHeight = GT.mainHeaderElm.clientHeight;
            document.documentElement.style.setProperty('--main-header-height', GT.mainHeaderElmHeight + 'px');
        }
    }, 500)
}

window.addEventListener("resize", function(){
    GT.wHeight = window.innerHeight;
    GT.wWidth = window.innerWidth;
    GT.bodyWidth = document.body.clientWidth;
    GT.scrollbarWidth = GT.wWidth - GT.bodyWidth;
    document.documentElement.style.setProperty('--scrollbar-width', GT.scrollbarWidth + 'px');
    document.documentElement.style.setProperty('--window-height', GT.wHeight + 'px');
    GT.recalculateHeaderHeight();
    
    GT.isMobileCached = GT.isMobile();
});

window.addEventListener("resize", GT.debounce(function(){
    //resize event always fires in Mobile browser if scrolling, because of browser's menu bar
    if(!GT.isMobileCached || isOrientationChange) {
        GT.hideHyperLinkAnimation();
        Object.keys(GT.windowResizeFncList).forEach(function(k) {
            if(typeof GT.windowResizeFncList[k] == "function")
                GT.windowResizeFncList[k]();
        })
        GT.recalculateHeaderHeight();
    }
    isOrientationChange = false;
}, 250));

document.addEventListener('touchmove', function(e){
    Object.keys(GT.touchMoveFncList).forEach(function(k) {
        GT.touchMoveFncList[k](e);
    })
}, {passive: false});